<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import service from '../../../../domain/leiloes/services'
  import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'
  import RelatorioLoading from './_RelatorioLoading'

  export default {
    components: {RelatorioLoading},
    nome: 'relatorio-leilao-lances',
    directives: {mask},
    data () {
      let situacaoLote = [
        {label: 'Vendidos', value: 6, class: 'btn-default'}, /*,  class: 'btn-info' */
        {label: 'Condicionais', value: 7, class: 'btn-default'}, /*,  class: 'btn-primary' */
        {label: 'Sem licitantes', value: 8, class: 'btn-default'}, /* , class: 'btn-success' */
        {label: 'Baixa Oferta', value: 9, class: 'btn-default'}, /* , class: 'btn-success' */
        {label: 'Retirados', value: 10, class: 'btn-default'} /* , class: 'btn-success' */
      ]
      return {
        isLoading: false,
        leilao: null,
        tiposLeilao: [
          {label: 'Qualquer', value: '', class: 'btn-default'},
          {label: 'Online', value: 2, class: 'btn-default'},
          {label: 'Presencial', value: 1, class: 'btn-default'}
        ],
        situacaoLote: situacaoLote,
        filterKey: '',
        sortKey: '',
        filtro: {
          tipo: '',
          situacao: situacaoLote.map(a => a.value)
        },
        sortOrders: {
          'numero': 1,
          'titulo': 1,
          'comitente': 1
        },
        showFiltros: false
      }
    },
    computed: {
      filteredData: function () {
        let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let filtrosFixos = this.filtro
        let order = this.sortOrders[sortKey] || 1
        let data = this.leilao.lotes
        // let tipo = this.filtro.tipo
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }

        // Situação
        data = data.filter(function (row) {
          return filtrosFixos.situacao.some(el => el === row.status)
        })

        // Tipo
        console.log(filtrosFixos.tipo)
        if (filtrosFixos.tipo) {
          data = data.filter(function (row) {
            if (!row.arremate) {
              return false // Não foi arrematado
            }
            let test
            if (filtrosFixos.tipo === 2) { // Online
              test = row.arremate.arrematante.apelido !== 'PLATEIA'
            } else if (filtrosFixos.tipo === 1) { // Presencial
              test = row.arremate.arrematante.apelido === 'PLATEIA'
            } else {
              test = true
            }
            return test
          })
        }

        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      },
      getStatus () {
        return Status.Status
      },
      Status () {
        return Status
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.isLoading = true
      service.getLeilaoLances(this.$route.params.id)
        .then((response) => {
          this.isLoading = false
          this.leilao = response.data
        })
        .catch((response) => {
          this.isLoading = false
          console.log(response)
        })
    },
    deactivated () {
    },
    watch: {},
    methods: {
    }
  }
</script>

<template>
  <div class="r-container" :class="{'is-loading': isLoading}">
    <relatorio-loading v-if="isLoading"></relatorio-loading>
    <transition name="slide">
      <div v-if="!isLoading" class="content-transition relatorio-print" id="container-printer">

        <div class="hidden-print">
          <div class="text-center m-t m-b-n">
            <h3 @click="showFiltros = !showFiltros" class="btn m-t-none"><span class="btn btn-default btn-xs m-r-xs">{{ !showFiltros ? '+' : '-' }}</span>Filtros</h3>
          </div>
          <div class="r-table" v-show="showFiltros">
            <div class="r-table-content">
              <div class="m-t">
                <div class="m-b">
                  <div>Tipo de Venda:</div>
                  <u-button-group v-model="filtro.tipo" :options="tiposLeilao"></u-button-group>
                </div>
                <div class="m-b">
                  <div>Situação:</div>
                  <u-button-group :multiSelect="true" v-model="filtro.situacao"
                                  :options="situacaoLote"></u-button-group>
                </div>
                <div class="m-b">
                  Resultados: {{ filteredData && filteredData.length }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hidden-print">
          <h2 class="text-center text-uppercase font-bold m-b-none">Relatório de Lances</h2>
          <h4 class="text-center text-uppercase">Leilão Realizado {{ moment(leilao.dataAbertura.date).format('LLLL')
            }}</h4>
        </div>
        <div v-for="(lote, key) in filteredData" class="printer-page pos-rlt">
          <div class="visible-print">
            <h2 class="text-center text-uppercase font-bold m-b-none">Relatório de Lances</h2>
            <h4 class="text-center text-uppercase">Leilão Realizado {{ moment(leilao.dataAbertura.date).format('LLLL')
              }}</h4>
          </div>
          <div class="r-table">
            <div class="r-table-header">
              <div class="pull-left font-bold text-black">{{ lote.titulo }}</div>
              <div class="pull-right font-bold"><h3 class="m-t-none">Lote {{ lote.numero }}</h3></div>
              <div class="clearfix"></div>
            </div>
            <div class="r-table-content">
              <table class="w-full m-b" cellpadding="0" cellspacing="0">
                <tr>
                  <td>Comitente: <strong>{{ lote.comitente.pessoa.nome }}</strong></td>
                  <td class="text-right">Situação: <strong :class="'text-' + Status.Status[lote.status].class">{{
                    Status.Status[lote.status].titulo }}</strong></td>
                </tr>
                <tr>
                  <td>Quantidade de lances: <strong>{{ lote.lances ? lote.lances.length : 0 }}</strong></td>
                  <td class="text-right"><span v-if="lote.arremate">Vencedor: <strong><!--{{ lote.arremate.arrematante.pessoa.nome }}--> {{ lote.arremate.arrematante.apelido }}</strong></span></td>
                </tr>
              </table>

              <table class="table table-bordered r-table-min">
                <thead>
                <tr>
                  <th>Data</th>
                  <th>Apelido</th>
                  <th style="white-space: nowrap">Nome</th>
                  <th>Valor</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="lance in lote.lances">
                  <td>
                    {{ moment(lance.data.date).format('L') }} {{ moment(lance.data.date).format('LTS') }}
                  </td>
                  <td>
                    <router-link target="_blank" :to="{name: 'arrematante.visualizar', params: {id: lance.arrematante.id}}">{{ lance.arrematante.apelido }}</router-link>
                  </td>
                  <td>{{ lance.arrematante.pessoa.nome }}</td>
                  <td>R$ {{ lance.valor | moeda }}</td>
                </tr>
                <tr v-if="!lote.lances || lote.lances.length === 0">
                  <td colspan="3" class="no-borders" style="border-bottom: none"><span class="text-danger">Nenhum lance</span></td>
                </tr>
                </tbody>
              </table>

            </div>
          </div>
          <div class="p-page-numer visible-print">Página {{key+1}} de {{filteredData && filteredData.length}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>



// WEBPACK FOOTER //
// RelatorioLances.vue?23f35637